import React from 'react'
import HeaderStyle from '../styles/HeaderStyle'
import MenuDrawer from '../components/MenuDrawer'
import Button from './Button'
import MenuNav from './MenuNav'

const Header = ({ handleScroll, functionsRef, pricesRef }) => {
  return (
    <>
      <HeaderStyle>
        <header>
          <nav id="menu" className="navbar">
            <div className="navbar-header">
              <span className="navbar-brand">
                raks
                <img
                  className="logo-opis"
                  src={require('../assets/images/30.png')}
                  alt="logotyp"
                />
              </span>
            </div>
            <MenuNav
              handleScroll={handleScroll}
              functionsRef={functionsRef}
              pricesRef={pricesRef}
            />
            <MenuDrawer
              handleScroll={handleScroll}
              functionsRef={functionsRef}
              pricesRef={pricesRef}
            />
          </nav>
          <div className="desc-container">
            <h1>
              E-sprawozdania finansowe online
              <br />
              zgodne ze specyfikacją Ministerstwa Finansów
            </h1>
            <div className="flex-container">
              <figure className="screen">
                <img
                  width="100%"
                  height="auto"
                  src={require('../assets/images/S1.png')}
                  alt="screen"
                />
              </figure>
            </div>
          </div>
        </header>
        <section id="sectionBtn" className="flex-container">
          <Button link="/app/?path=account" title="wypróbuj za darmo" />
        </section>
      </HeaderStyle>
    </>
  )
}

export default Header
